export const EDIT_BANK_DETAILS = "/fund/update_bank_details/";
